import { gql } from '@apollo/client';

// Household Subscriptions
export const ON_HOUSEHOLD_UPDATE = gql`
  subscription OnHouseholdUpdate($householdId: ID!) {
    onHouseholdUpdate(householdId: $householdId) {
      id
      name
      ownerId
      members
      settings {
        location
        weeklyBudget
        mealPrepTime
        dietaryPreferences
        allergies
        equipment
      }
      updatedAt
    }
  }
`;

// Pantry Subscriptions
export const ON_PANTRY_ITEM_CHANGE = gql`
  subscription OnPantryItemChange($householdId: ID!) {
    onPantryItemChange(householdId: $householdId) {
      householdId
      itemId
      name
      category
      quantity
      unit
      expiryDate
      addedDate
      normalizedIngredientId
      perishabilityScore
      updatedAt
    }
  }
`;

// Meal Plan Subscriptions
export const ON_MEAL_PLAN_UPDATE = gql`
  subscription OnMealPlanUpdate($householdId: ID!) {
    onMealPlanUpdate(householdId: $householdId) {
      householdId
      planId
      weekStart
      weekEnd
      planSlots {
        date
        mealType
        recipeId
        recipeName
        recipeImage
        recipeStub {
          id
          title
          image
          readyInMinutes
          servings
          sourceUrl
          summary
          nutrition {
            calories
            protein
            carbs
            fat
          }
        }
        status
        servings
      }
      nutritionSummary {
        dailyAverages {
          calories
          protein
          carbs
          fat
          fiber
          sugar
          sodium
        }
        weeklyTotals {
          calories
          protein
          carbs
          fat
          fiber
          sugar
          sodium
        }
      }
      status
      updatedAt
    }
  }
`;

// Grocery List Subscriptions
export const ON_GROCERY_LIST_UPDATE = gql`
  subscription OnGroceryListUpdate($householdId: ID!) {
    onGroceryListUpdate(householdId: $householdId) {
      householdId
      listId
      planId
      items {
        id
        name
        quantity
        unit
        category
        aisle
        checked
        recipeIds
        notes
      }
      instacartLinkUrl
      status
      updatedAt
    }
  }
`;
